import { useEffect, useState } from "react"
import { getJsonFromString, ReadObjectProp } from "../../../common/commonHelper"
import { getStorageFieldLabel, getStorageIcon, storageConfigData } from "./configData"
import { ChildFieldForm } from "../childForm/ChildFieldForm"
import { ChildFormController } from "../childForm/childFormController"
const _props = {
    type: '',
    field: {},
    inputForm: {},
    controlConfig: {}
}
export function StorageConfig(props = _props) {
    const { formState: { errors }, getValues: inputForm_getValues, setValue: setInputFormValue } = props.inputForm;
    const parent_field = props.controlConfig?.mappedParentField;
    const parent_field_value = (inputForm_getValues() || {})[parent_field];
    const sourceConfig = storageConfigData.find(x => x.type === parent_field_value)


    const fields = sourceConfig?.config ? Object.keys(sourceConfig.config) : [];

    const childFormConfig = fields.map(x => {
        return {
            field: x,
            edit: {
                enabled: true,
                type: "textbox",
                htmlAttributes: {
                    placeholder: `Enter ${x}`
                },
                name: x,
                label: getStorageFieldLabel(x),
                editable: true,
                rules: {
                    required: {
                        value: true,
                        message: `${x} is required.`
                    }
                }
            }
        }
    })
    

    return  <ChildFormController
            controlConfig={props.controlConfig}
            currentFormField={props.field}
            inputForm={props.inputForm}
        childFormConfig={childFormConfig}
        backgroundColor={'aliceblue'}
        />
}

